import { Icon, IconType } from "@justhome/react-ui";
import clsx from "clsx";
import { FC } from "react";

const CalculationIcon: FC<{
  icon: IconType;
  primary?: boolean;
  className?: string;
}> = ({ icon, primary, className }) => {
  return (
    <div
      className={clsx(
        "flex bg-neutral-50 rounded-m h-2s w-m items-center justify-center flex-none",
        {
          "text-primary-800": primary,
        },
        className,
      )}
    >
      <Icon size={16} type={icon} />
    </div>
  );
};

export default CalculationIcon;
